import { styled } from "@pigment-css/react";
import { Flex } from "../../../primitives/Flex";

interface CustomerDetailsHeaderProps {
  clientName: string;
  externalReference: string | null;
  region: string;
  employeeName: string;
  dateSelector?: React.ReactNode;
  onEmployeeClick?: () => void;
}

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: theme.managementView.spacing[16],
}));

const ClientName = styled("h2")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[21],
  fontWeight: theme.managementView.font.weight[500],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[90],
  margin: 0,
}));

const Subtitle = styled("p")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[16],
  fontWeight: theme.managementView.font.weight[500],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[56],
  margin: 0,
}));

const ClickableEmployeeName = styled("span")(({ theme }) => ({
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
  color: theme.managementView.colors.neutral[56],
}));

const DateSelectorContainer = styled("div")({
  flexShrink: 0,
});

export const CustomerDetailsHeader = ({
  clientName,
  externalReference,
  region,
  employeeName,
  dateSelector,
  onEmployeeClick,
}: CustomerDetailsHeaderProps) => {
  const prefixParts: string[] = [];
  if (externalReference) prefixParts.push(`#${externalReference}`);
  if (region) prefixParts.push(region);

  const prefix = prefixParts.length > 0 ? prefixParts.join(" · ") : null;
  const hasSubtitle = prefix || employeeName;

  return (
    <HeaderWrapper>
      <Flex direction="column" gap={4}>
        <ClientName>{clientName}</ClientName>
        {hasSubtitle && (
          <Subtitle>
            {prefix && `${prefix}${employeeName ? " · " : ""}`}
            {employeeName && onEmployeeClick ? (
              <ClickableEmployeeName onClick={onEmployeeClick}>{employeeName}</ClickableEmployeeName>
            ) : (
              employeeName
            )}
          </Subtitle>
        )}
      </Flex>
      {dateSelector && <DateSelectorContainer>{dateSelector}</DateSelectorContainer>}
    </HeaderWrapper>
  );
};
